import React from 'react';
import { LandmarkIcon, ChevronLeftIcon } from 'lucide-react';
export function LandmarkSelector({
  country,
  onSelectLandmark,
  onBack
}) {
  return <div className="p-6" data-id="element-47">
      <div className="flex items-center mb-6" data-id="element-48">
        <button onClick={onBack} className="mr-3 p-2 hover:bg-gray-100 rounded-full" data-id="element-49">
          <ChevronLeftIcon className="h-5 w-5 text-gray-600" data-id="element-50" />
        </button>
        <h2 className="text-2xl font-semibold text-gray-800" data-id="element-51">{country.name}</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-52">
        {country.landmarks.map(landmark => <button key={landmark.id} className="bg-white overflow-hidden rounded-xl shadow-sm hover:shadow-md transition-shadow text-left flex flex-col" onClick={() => onSelectLandmark(landmark)} data-id="element-53">
            <div className="h-40 bg-cover bg-center" style={{
          backgroundImage: `url(${landmark.imageUrl})`
        }} data-id="element-54" />
            <div className="p-4" data-id="element-55">
              <h3 className="font-semibold text-lg text-gray-800" data-id="element-56">
                {landmark.name}
              </h3>
              <p className="text-gray-500 text-sm mt-1" data-id="element-57">
                {landmark.locations.length} audio tours
              </p>
            </div>
          </button>)}
      </div>
    </div>;
}